<template>
  <footer class="bg-white dark:bg-gray-900 shadow-md">
    <div class="container mx-auto px-4">
      <!-- Footer Content -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
       
        <!-- Quick Links -->
        <div>
          <h3 class="text-xl font-bold mb-4">{{ $t('footer.quickLinks') }}</h3>
          <ul class="space-y-2">
            <li v-for="item in navItems" :key="item.path">
              <router-link 
                :to="item.path" 
                class="text-gray-400 hover:text-white transition-colors"
              >
                {{ $t(item.label) }}
              </router-link>
            </li>
          </ul>
        </div>
        
        <!-- Contact Info -->
        <div>
          <h3 class="text-xl font-bold mb-4">{{ $t('contact.title') }}</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <i class="fas fa-map-marker-alt mt-1 mr-3 text-primary"></i>
              <span class="text-gray-400">
                {{ $t('contact.address') }}
              </span>
            </li>
            <li class="flex items-center">
              <i class="fas fa-phone-alt mr-3 text-primary"></i>
              <span class="text-gray-400">{{ $t('nextStep.contactInfo.phoneNote') }}</span>
            </li>
            <li class="flex items-center">
              <i class="fas fa-envelope mr-3 text-primary"></i>
              <span class="text-gray-400">{{ $t('nextStep.contactInfo.emailNote') }}</span>
            </li>
          </ul>
        </div>
      </div>
      
      <!-- Bottom Bar -->
      <div class="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
        <p class="text-gray-500 text-sm mb-4 md:mb-0">
          {{ $t('footer.copyright', { year: new Date().getFullYear() }) }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Navigation Items
const navItems = [
  { path: '/', label: 'navigation.home' },
  { path: '/approach', label: 'navigation.approach' },
  { path: '/evidence', label: 'navigation.evidence' },
  { path: '/insights', label: 'navigation.insights' },
  { path: '/next-step', label: 'navigation.nextStep' },
];
</script>
